import { Badge, IconButton, Tooltip } from "@mui/material";
import { NotificationsOutlined as NotificationsIcon } from "@mui/icons-material";
import { useState } from "react";
import { useAdminMessages } from "../../contexts/AdminMessageContext";
import MessageInboxDrawer from "./MessageInboxDrawer";

// Shared bordered "icon-btn" style — matches the marketplace and AI buttons in TopNav.
const iconBtnSx = {
  width: 34,
  height: 34,
  border: "1px solid",
  borderColor: "neutral.100",
  backgroundColor: "transparent",
  color: "text.secondary",
  "&:hover": {
    borderColor: "neutral.400",
    color: "text.primary",
    backgroundColor: "background.default",
  },
};

const MessageBell = () => {
  const { unreadCount } = useAdminMessages();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="הודעות מערכת">
        <IconButton onClick={() => setOpen(true)} sx={iconBtnSx}>
          <Badge
            color="error"
            variant="dot"
            invisible={!unreadCount}
            overlap="circular"
          >
            <NotificationsIcon sx={{ fontSize: 16 }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <MessageInboxDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default MessageBell;
